import React from 'react';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { Key as PasskeyIcon, PhonelinkLock as AuthenticatorAppIcon } from '@mui/icons-material';
import type { ActionName } from '../../utils/actionReturn';

// "Add passkey" and "Add authenticator app" for both apps' user menus (SF-167, D-1). Returned as
// an array, not a wrapper component, so MUI's Menu keeps managing focus on each item.
export const signInMethodMenuItems = (onAdd: (action: ActionName) => void): React.ReactElement[] => [
  <MenuItem key="add-passkey" onClick={() => onAdd('webauthn-register')}>
    <ListItemIcon>
      <PasskeyIcon fontSize="small" />
    </ListItemIcon>
    <ListItemText>Add passkey</ListItemText>
  </MenuItem>,
  <MenuItem key="add-authenticator-app" onClick={() => onAdd('CONFIGURE_TOTP')}>
    <ListItemIcon>
      <AuthenticatorAppIcon fontSize="small" />
    </ListItemIcon>
    <ListItemText>Add authenticator app</ListItemText>
  </MenuItem>,
];
